var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCurrentMemberByWorkspaceId } from '#query-hooks';
export const useCanAdminFilespace = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { query: { data, isLoading }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { filespaceAdminFor = {}, privileges } = data || {};
    const { canAdminFilespaces } = privileges ?? {};
    if (!canAdminFilespaces) {
        return {
            isLoading,
            canAdminFilespace: false,
        };
    }
    if (filespaceAdminFor === 'all') {
        return {
            isLoading,
            canAdminFilespace: true,
        };
    }
    return {
        isLoading,
        canAdminFilespace: Boolean(filespaceAdminFor[filespaceId]),
    };
};
_react_refresh_temp_1(useCanAdminFilespace, "K7PBR93N11IrGefSWA750ZwQ+9Q=", false, () => [useCurrentMemberByWorkspaceId]);
